import styled from 'styled-components'
import { Arrow as ArrowRight } from '../../../../assets'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 10px;
  height: 90px;

  @media (min-width: 768px){
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    padding-right: 30px;
  }
`

export const ButtonExplore = styled.div`
  color: #FFF;
  cursor: pointer;
  border-bottom: solid 1px #FFF;
  letter-spacing: 1px;

  @media (max-width: 767px) {
    margin-left: auto;
    span {
      text-transform: lowercase;
      font-size: 14px;
    }
  }
`

export const FooterDiv = styled.div`
  color: #fff;
  grid-row: 3;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  @media (max-width: 767px) {
    margin-top: 2em;
    grid-row: 2;
    font-size: 18px;
    max-height: 200px;
  }
`;

export const ItensDiv = styled.div`
  img {
    margin-right: 20px;
  }
`;

export const ButtonVisitShowroom = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Amorim Sans Book', sans-serif;
  cursor: pointer;
  color: #a2cbc8;
  width: 210px;
  height: 38px;
  letter-spacing: .8px;
  font-size: 20px;

  @media (max-width: 767px) {
    margin: 0 auto;
    width: 186px;
    text-transform: lowercase;
    
  }

  a {
    text-decoration: none;
    color: #fff;
  }

  &:hover {
        :after {
            transform: translate(0, -40%) scale(.8);
        }
    }

    &:after {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(-8px, -40%) scale(.8);
        content: '';
        width: 30px;
        height: 10px;
        mask: url(${ArrowRight}) no-repeat;
        mask-size: 50% 90%;
        background: #a2cbc8;
        margin-left: 10px;
        transition: all .2s ease-out;
    }

`;

export const StyledClose = styled.div`
  svg {
    width: 2em;
    height: 2em;

    path {
      stroke: #fff;
      stroke-width: 0.78;
    }
  }
`;
